import { NewCustomFieldOption } from './CustomFieldsMenu';

export const CUSTOM_FIELDS: Array<NewCustomFieldOption> = [
  {
    config: null,
    name: 'Phone number',
    type: 'phoneNumber',
  },

  {
    config: null,
    name: 'Email',
    type: 'email',
  },

  {
    config: null,
    name: 'URL',
    type: 'url',
  },
  {
    config: null,
    name: 'Text',
    type: 'text',
  },
  {
    config: null,
    name: 'Number',
    type: 'number',
  },
  {
    config: null,
    name: 'Address',
    type: 'address',
  },
  {
    config: null,
    name: 'Tags',
    type: 'multiSelect',
    options: [],
  },
];
